import React from "react";
import EventCard from "../components/card/EventCard";
import Footer from "../components/layout/Footer";
import Header from "../components/layout/header/Header";
const LandingPage = () => {
  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row justify-content-evenly ms-md-5 firstArticle ">
          <div className="col-md-5">
            <img
              src="/assests/landingPic1.png"
              alt="Game Picture"
              className="img-fluid"
            />
          </div>

          <div className="pb-2 py-5 col-md-7 ps-md-5">
            <h2 className="pr-4 mb-3 heading">
              <span className="fw-bold textViolet">
                Real-Money Sports Tournaments
              </span>
            </h2>

            <p className="text-secondary ps-md-4 px-md-1 firstNews">
              Our number one priority is to make sure you are entering and
              participating in real-money sports tournaments both safely and
              responsibly. We provide our customers with access to a variety of
              information designed to encourage safe choices and discourage
              unsafe behavior.
            </p>
          </div>
        </div>
        <div
          className="row"
          style={{
            background:
              " url('/assests/landingPic2.png') no-repeat center center/cover",
          }}
        >
          <div
            className="col-md-7 pt-4 pb-5 pe-1 secondNews"
            style={{ paddingLeft: "5%" }}
          >
            <p className="pt-5 heading" style={{ lineHeight: "2.7rem" }}>
              <span className="fw-bold pb-0">
                KIBI Sports platform provides
              </span>
            </p>
            <p className="" style={{ marginRight: "0%" }}>
              Information to assist players in making informed decisions about
              their play, including:<br></br>
              <br></br>
              1) Practical tips on how to keep playing within self-imposed
              limits.<br></br>
              2) Information on how contests work, including the payout ratios
              where<br></br>
              applicable.<br></br>
              3) How to use responsible play tools such as limit setting and
              self-exclusion<br></br>
              options.<br></br>
              4) Preventing play by underage Providing contact information and
              direct links to<br></br>
              the help resources available for players identified as potentially
              experiencing <br></br>
              problem gaming. Making direct links to help resources available to
              all users via this page.
            </p>
          </div>
        </div>

        <div className="text-center mt-3 py-5 tradingEvents">
          <h2 className="fw-bold pb-md-4 heading d-md-flex gap-2 justify-content-center">
            <span className="textViolet">Trading&nbsp;</span>
            <h2>Events</h2>
          </h2>
          <p className="col-12 fs-5 text-secondary">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a gallery of type
            and scrambled.
          </p>
        </div>
        <EventCard />
        {/* <Footer /> */}
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;
